var $ = require('jquery');

$(function () {
    $('.link--search').on('click', function (e) {
        e.preventDefault();
        $('body').toggleClass('show-search').removeClass('show-location-menu');
        $('.search').slideToggle();
        $('.locations, .header__sub-menu').slideUp();
        $('.header__main-menu__primary-link').removeClass('open');
    });
    $('.link--search, .search').on('click', function (e) {
        e.stopPropagation();
    });
    $('body').on('click', function (e) {
        //stopPropagation doesn't work on andriod devices. Need to allow the user to click into the search text bar without closing the menu
        if ($(e.target).is('.show-search')) {
            return false;
        } else {
            $(this).removeClass('show-search');
            $('.search').slideUp();
        }
    });
    
});
